<main class="p-6 bg-lGray950 rounded-3xl">
  <div class="mb-5 flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
    <div>
      <h1 class="text-[2.05rem] font-bold leading-8 text-color">Usuários</h1>
      <p class="mt-1 text-sm subtext-color">Gerencie os usuários da plataforma</p>
    </div>

    <div class="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-end xl:w-auto">
      <div class="relative w-full sm:w-[388px]">
        <l-icon class="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-[1.35rem] text-lGray600" icon="search" />
      <input
        lInput
        class="w-full !h-10 !rounded-full !bg-lGray900 !border-lGray700 !text-lSecondary placeholder:!text-lSecondary !pl-14 !pr-5 !text-base"
        placeholder="Pesquisar usuário"
        [formControl]="searchControl"
      />
      </div>

      <div class="flex gap-3">
      <button
        lButton
        [bType]="buttonTypeEnum.OUTLINE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        class="!h-10 !min-w-[180px] !px-8 !text-base"
        (click)="openImportUsersModal()"
      >
        Importar
      </button>
      <button
        lButton
        [bType]="buttonTypeEnum.PRIMARY"
        [bSize]="buttonSizeEnum.MEDIUM"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        class="!h-10 !min-w-[180px] !px-8 !text-base"
        (click)="openCreateUserModal()"
      >
        {{ hasSSO ? 'Convidar usuário' : 'Criar usuário' }}
      </button>
      </div>
    </div>
  </div>

  <l-users-table
    [size]="size"
    [page]="page"
    [data]="source.data"
    [sort]="sort"
    [total]="source.total"
    [isLoading]="isLoading"
    [hasSSO]="hasSSO"
    [getUserStatus]="getUserStatus.bind(this)"
    [getRowActions]="getRowActions.bind(this)"
    (pageChange)="onChangePage($event)"
    (sortChange)="onChangeSort($event)"
  />
</main>
